import { DELETE_ISSUE_NOTE } from '../../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case DELETE_ISSUE_NOTE.LOAD:
      return {
        ...state,
        loading: true,
      };
    case DELETE_ISSUE_NOTE.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case DELETE_ISSUE_NOTE.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
